module.exports = __webpack_public_path__ + "img/product.d8005ee2.png";